__turbopack_context__.v({
  "notice": "WhiteboardPracticeSelectionNotice-module__KfXQeW__notice",
  "selection-fade": "WhiteboardPracticeSelectionNotice-module__KfXQeW__selection-fade",
});
